module.exports = __webpack_public_path__ + "img/single_pictures_8.9c09de65.jpg";